import logo from './logo.svg';
import './App.css';
import Container from './components/Container';

function App() {
  return (
    <Container></Container>
  );
}

export default App;
